var map = {
	"./app_cn.json": [
		2256,
		2256
	],
	"./app_en.json": [
		1186,
		1186
	],
	"./app_kz.json": [
		3508
	],
	"./app_ru.json": [
		6868,
		6868
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4020;
module.exports = webpackAsyncContext;